import { AwsPartitionElement } from "@p0security/integrations-aws-shared/components";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

import {
  BUCKET_NAME_VALIDATION_ERROR_MSG,
  REGION_VALIDATION_ERROR_MSG,
  isAwsRegion,
  isBucketName,
} from "./bucket.ts";

export const AwsS3AuditComponents = InstallSpec({
  "audit-log": ItemComponent({
    type: "string",
    label: "Bucket name",
    description:
      "Allows P0 to write access events and security findings as files to an Amazon S3 bucket",
    maturity: "beta",
    validator: async (_context: any, id: string) => {
      if (!isBucketName(id)) return BUCKET_NAME_VALIDATION_ERROR_MSG;
    },
    schema: {
      accountId: Element({
        label: "AWS account ID",
        description:
          "The AWS account that owns the bucket. P0's AWS integration must be installed for this account.",
        type: "dynamic",
        step: "new",
      }),
      awsPartition: AwsPartitionElement,
      region: Element({
        label: "Region",
        description: "The AWS region the bucket is in.",
        type: "string",
        step: "new",
        validator: async (_id, field) => {
          if (!isAwsRegion(field ?? "")) return REGION_VALIDATION_ERROR_MSG;
        },
      }),
      serviceAccountEmail: Element({
        label: "P0 service account email",
        type: "hidden",
      }),
      serviceAccountId: Element({
        label: "P0 service account ID",
        type: "hidden",
      }),
    },
    maxItems: 1,
  }),
});
